export const loggedInRequest = () => {
    return {
        type: 'USER_GET_ME_REQUESTING'
    }
}
